import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { styles } from "./styles";
import { styles as sidebarStyles } from "./../SideBar/styles";
import subItemIcon from "assets/sub-item.svg";
import selectedSubItemIcon from "assets/selected-sub-item.svg";

type ExpandableSidebarItemProps = {
  selectedPage: string;
  handleSelectPage: (path: string) => void;
  basePath: string;
  title: string;
  subPages: { name: string; path: string }[];
  icon: string;
};

const ExpandableSidebarItem = ({
  selectedPage,
  handleSelectPage,
  basePath,
  title,
  subPages,
  icon
}: ExpandableSidebarItemProps) => {
  const classes = styles();
  const sidebarClasses = sidebarStyles();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => {
    if (!isExpanded || location.pathname.includes(basePath)) {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <>
      <Link
        className={sidebarClasses.pageLinks}
        to={subPages[0].path}
        onClick={() => toggleExpand()}
      >
        <p
          className={
            selectedPage.includes(basePath)
              ? sidebarClasses.linkSelected
              : sidebarClasses.links
          }
        >
          <span
            className={`${sidebarClasses.LinkNameContainer} ${
              location.pathname.includes(basePath) &&
              sidebarClasses.activeLink
            }`}
          >
            <img
              src={icon}
              alt={title}
              className={sidebarClasses.linkIcon}
            />
            <p>{title}</p>
          </span>
        </p>
      </Link>
      {isExpanded && (
        <>
          {subPages.map(({ name, path }) => (
            <Link
              className={sidebarClasses.pageLinks}
              to={path}
              onClick={() => handleSelectPage(path)}
            >
              <p
                className={
                  selectedPage === path
                    ? classes.subLinkSelected
                    : sidebarClasses.links
                }
              >
                <span
                  className={`${sidebarClasses.LinkNameContainer} ${
                    location.pathname === path &&
                    sidebarClasses.activeLink
                  }`}
                >
                  <img
                    src={
                      selectedPage === path
                        ? selectedSubItemIcon
                        : subItemIcon
                    }
                    alt={name}
                  />
                  <p>{name}</p>
                </span>
              </p>
            </Link>
          ))}
        </>
      )}
    </>
  );
};

export default ExpandableSidebarItem;
